<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="750px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div>
        <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="120px"
          >
            <el-form-item label="职员名称/编号:" prop="staffName">
              <el-input
                v-model="searchForm.staffName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="" style="float: right">
              <el-button size="small" type="primary" @click="onSearch">查询</el-button>
              <el-button size="small" @click="resetSearchForm">重置</el-button>
            </el-form-item>
          </el-form>
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="400">
          <el-table-column prop="staffName" label="职员名称" align="center" width="90"></el-table-column>
          <el-table-column prop="staffCode" label="职员编码" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="isDelete" label="是否离职" show-overflow-tooltip align="center" width="80">
            <template slot-scope="{row}">
              {{row.isDelete == '0' ? '否' : '是'}}
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="参与时间" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="browseNumber" label="浏览次数" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column prop="browsePeopleNumber" label="浏览人数" align="center" width="80"></el-table-column>
        </el-table>
        <div style="text-align: right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
        <div style="text-align: center; margin-top: 20px">
          <el-button @click="onCancel" size="medium">关 闭</el-button>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: "up",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
    activityId: [Number,String],
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "职员信息";
    },
  },
  data() {
    return {
      loading: false,
      textForm: {},
      searchForm: {},
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    init() {
      let { storeCode } = this.rowData
      this.loading = true;
      let data = {
        filterData: {
          activityId: this.activityId,
          storeCode,
          ...this.searchForm
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$api.ActivityManagement
        .activityJoinStaffInfo(data)
        .then((res) => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    onSearch() {
      this.pageNum = 1
      this.init()
    },
    resetSearchForm() {
      this.pageSize = 10
      this.$refs.searchForm.resetFields();
      this.onSearch();
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form-item {
  margin-bottom: 10px;
}
</style>
